<template>
  <div class="cr-addresses">
    <div class="cr-container">
      <div class="cr-addresses__body">
        <div v-if="addressesLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
        <div v-if="addressesError" class="cr-detail-card__message cr-message cr-message--error">{{ addressesError }}</div>
        <div v-if="serverError" class="cr-detail-card__message cr-message cr-message--error" v-html="serverError"></div>
        <ul v-if="addressesLoaded" class="cr-addresses__list">
          <li v-for="item in addresses" class="cr-addresses__item">
            <div class="cr-address-card">
              <div class="cr-address-card__title">
                <div class="cr-address-card__name">
                  {{ item.name }}
                </div>
                <div class="cr-address-card__address">
                  {{ item.address }}
                </div>
              </div>
              <div class="cr-address-card__action">
                <button @click="deleteAddress(item.id)" class="cr-button cr-button--light" type="button">
                                        <span class="cr-button__text">
                                            Удалить
                                        </span>
                </button>
                <router-link :to="'/personal/address/'+item.id+'/'" class="cr-button cr-button--light">
                                        <span class="cr-button__text">
                                            Изменить
                                        </span>
                </router-link>
              </div>
            </div>
          </li>
        </ul>
        <router-link class="cr-button cr-button--light" to="/personal/address/0/">
                        <span class="cr-button__text">
                            Создать новый
                        </span>
        </router-link>
      </div>
      <div class="cr-text" v-if="false">
        <h3>
          Как это работает
        </h3>
        <p>
          Текст о том, как работает создание адреса. Текст о том, как работает создание адреса. Текст о том, как работает создание адреса. Текст о том, как работает создание адреса. Текст о том, как работает создание адреса. Текст о том, как работает создание адреса. Текст о том, как работает создание адреса.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapGetters} from "vuex";
import scrollToError from "@/mixin/scrollToError.vue";

export default {
  data: () => ({
    isSubmitting: null,
    serverError: null
  }),
  mixins: [scrollToError],
  created() {
    this.fetchAddresses();
  },
  computed: {
    ...mapGetters('address', [
      'addresses',
      'addressesLoading',
      'addressesError',
      'addressesLoaded'
    ]),
  },
  methods: {
    ...mapActions('address', [
      'fetchAddresses'
    ]),
    async deleteAddress(id) {
      if (!id) {
        return;
      }

      this.isSubmitting = true;
      this.serverError = null;

      try {
        const response = await axios.post('/api/user/address/remove/'+id+'/');
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code != 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(response.data.errors);
        }
        this.fetchAddresses();

      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },

  }
}
</script>
